import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';
import { getReactors } from 'helpers/reactionHelpers';
import ReactionButton from 'components/ReactionButton';

import { Post } from 'types/post';
import { ReplyEdgeFieldsFragment as Comment } from '__generated__/graphql/legacy/graphql';

import { REACTION_TYPES } from 'utils/constants';

import { Button } from '@thinkific/chalk';
import { Chats } from '@thinkific/chalk/react-icons';

import styles from '../Post.module.scss';

const cx = classNames.bind(styles);

interface PostHeaderProps {
  hasReacted: boolean;
  post: Post | Comment;
  openReplyPanel: () => void;
  totalCommentCount: number;
  postReactionCount: number;
  isReplyPanel: boolean;
}

const PostFooter: React.FC<PostHeaderProps> = ({
  hasReacted,
  post,
  postReactionCount,
  openReplyPanel,
  totalCommentCount,
  isReplyPanel,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx('post__footer')}>
      <div>
        <ReactionButton
          hasReacted={hasReacted}
          id={post.id}
          isReactingTo="post"
          postReactionCount={postReactionCount}
          reactionType={REACTION_TYPES.LIKE_POST}
          reactors={getReactors(post)}
          t={t}
        />
        {!isReplyPanel && (
          <Button
            data-qa="main-comments_text"
            emphasis="low"
            icon={Chats}
            iconPosition="lead"
            size="sm"
            onClick={openReplyPanel}
          >
            {totalCommentCount > 0
              ? t('{{count}} comment', { count: totalCommentCount })
              : t('Reply')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PostFooter;
